import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import { loginActions } from "../../actions/login";
import { deleteAllCookie } from "../../helper/cookie";
import { UserContext } from "../../context/userContext";

function Logout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(UserContext);

  useEffect(() => {
    // Xóa cookies và localStorage
    deleteAllCookie();
    localStorage.removeItem("token");

    // Reset Redux state
    dispatch(loginActions(false));

    // Reset Context user
    setCurrentUser(null);

    // Redirect về login
    navigate("/login", { replace: true });
  }, [dispatch, navigate, setCurrentUser]);

  return null;
}

export default Logout;
